import { useDispatch, useSelector } from "react-redux";
import { ButtonBase, Box } from "@mui/material";
import { Link } from "react-router-dom";
import config from "config";
import { MENU_OPEN } from "store/actions";

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
  const defaultId = useSelector((state) => state.customization.defaultId);
  const dispatch = useDispatch();

  return (
    <ButtonBase
      disableRipple
      component={Link}
      onClick={() => dispatch({ type: MENU_OPEN, id: defaultId })}
      to={config.defaultPath}
      sx={{
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        textDecoration: "none",
      }}
    >
      <Box
        component="img"
        src="/cafelogo.png"
        alt="CafeWafe"
        sx={{
          height: { xs: 30, sm: 34 },
          width: "auto",
          maxWidth: 160,
          objectFit: "contain",
          display: "block",
        }}
      />
    </ButtonBase>
  );
};

export default LogoSection;
